export default "__VITE_ASSET__DINR$tnl__"